import { render, staticRenderFns } from "./NotificationCollectionCentresApprovalRequestForm.vue?vue&type=template&id=daaf279e"
import script from "./NotificationCollectionCentresApprovalRequestForm.vue?vue&type=script&lang=js"
export * from "./NotificationCollectionCentresApprovalRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports